import React, { Component } from 'react';

// This spinner is coming from vxlib. It is the large green spinner
// http://vxlib/docs/#spinners

export class Spinner extends Component {

    render() {
        return (<div className="vx_spinner-large" />);
    }

}
